import { render, staticRenderFns } from "./ModuleSchedule.vue?vue&type=template&id=531e4bfa&scoped=true&lang=pug&"
import script from "./ModuleSchedule.vue?vue&type=script&lang=js&"
export * from "./ModuleSchedule.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSchedule.vue?vue&type=style&index=0&id=531e4bfa&lang=scss&scoped=true&"
import style1 from "./ModuleSchedule.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ModuleSchedule.vue?vue&type=style&index=2&id=531e4bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531e4bfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCalendar } from 'vuetify/lib/components/VCalendar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCalendar,VIcon})
